
const populateChildren = (node) => {
  const returnNode = {};
  returnNode.fieldName = node.name; // for some reason we want to rename this to 'fieldName'

  Object.keys(node).forEach((property) => {
    if (Object.prototype.hasOwnProperty.call(node, property) && property !== 'children' && property !== 'name') {
      returnNode[property] = node[property];
    }
  });

  if (node.children) {
    returnNode.details = node.children.map(populateChildren); // for some reason we rename this to 'details'
  }

  return returnNode;
};

const getModules = (config) => {
  if (config.children) {
    return config.children.map((child) => ({
      moduleName: child.name,
      details: child.children ?
        child.children.map(populateChildren) : null,
    }));
  }
  return [];
};

export const mapModules = (config) => {
  const modules = getModules(config) || [];
  return modules;
};
